export enum IconType {
  IONIC_ICON = 'IONIC_ICON',
  SVG = 'SVG'
}
